import React, { useEffect } from 'react';

import CreateCauzeView from './CreateCauzeView';
import useCreateCauze from 'hooks/useCreateCauze';
import withAuthRequired from 'behaviors/withAuthRequired';
import useDashboardStore from 'stores/DashboardStore';

const CompanyCreateCauzeView = ({ companyId, eventId }) => {
  const { setProps } = useDashboardStore();
  const { cauzeLoaded } = useCreateCauze({
    userContext: { companyId },
    eventId,
  });

  useEffect(() => {
    setProps({
      size: 'half',
    });
  }, []);

  return (
    <CreateCauzeView
      userContext={{ companyId }}
      eventId={eventId}
      cauzeLoaded={cauzeLoaded}
    />
  );
};

export default withAuthRequired(CompanyCreateCauzeView, {
  entityType: 'COMPANY',
});
